import { FEATURE_FLAGS } from 'dashboard/featureFlags';

/**
 * Whether the Aoikumo integration is available on an account.
 *
 * It needs both:
 * - `aoikumo_integration`, switched on per account by DahReply (off by default);
 * - `organization`, because Aoikumo links branches, services, staff and
 *   appointments, which only exist in the Organization feature. An account
 *   without it (for example co-living) has nothing to link.
 *
 * Used by the Integrations card, the Aoikumo page and the app-load fetch.
 *
 * @param {Function} isFeatureEnabled - the `accounts/isFeatureEnabledonAccount` getter
 * @param {String|Number} accountId
 * @returns {Boolean}
 */
export const hasAoikumoAccess = (isFeatureEnabled, accountId) =>
  !!isFeatureEnabled(accountId, FEATURE_FLAGS.AOIKUMO) &&
  !!isFeatureEnabled(accountId, FEATURE_FLAGS.ORGANIZATION);

export default hasAoikumoAccess;
